import { CONFIG } from '../../../config'
const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/fiscal`

export function urlNfses(tpId) {
  return `${BASE_URL}/${tpId}/nfse`
}

export function urlNfse(tpId, id) {
  return `${BASE_URL}/${tpId}/nfse/${id}`
}

export function urlEmissoresNfse(tpId) {
  return `${BASE_URL}/${tpId}/nfse/emissores`
}

export function urlTomadorNfse(tpId) {
  return `${BASE_URL}/${tpId}/nfse/tomador`
}

export function urlDadosEmissaoNfse(tpId) {
  return `${BASE_URL}/${tpId}/nfse/dados-emissao`
}

export function urlNotasDisponiveisNfse(tpId) {
  return `${BASE_URL}/${tpId}/nfse/notas`
}

export function urlSincronizarNfse(tpId, id) {
  return `${BASE_URL}/${tpId}/nfse/${id}/sincronizar`
}

export function urlCancelarNfse(tpId, id) {
  return `${BASE_URL}/${tpId}/nfse/${id}/cancelar`
}

export function urlEmailNfse(tpId, id) {
  return `${BASE_URL}/${tpId}/nfse/${id}/email`
}

export function urlDownloadNfse(tpId, ids) {
  // Download aberto em nova aba: token vai por query string para o authMiddleware
  return `${BASE_URL}/${tpId}/nfse/download?ids=${ids.join(',')}&t=${localStorage.getItem('t')}`
}
